import actions from './actions';

const state = {
    host: '',
    selfInfo: {},
};

export default {
    namespaced: true,
    state,
    actions,
};
